import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';
import queryString from 'query-string';

export default function getOrderDetails(params) {
    const { baseUrl, brandId, country, externalOrderId, uberToken, clientId, clientSecret, email, langId, withAccessProfile = true } = params;

    invariant(baseUrl, 'baseUrl is a required param of getOrderDetails()');
    invariant(brandId, 'brandId is a required param of getOrderDetails()');
    invariant(country, 'country is a required param of getOrderDetails()');
    invariant(externalOrderId, 'externalOrderId is a required param of getOrderDetails()');
    invariant(clientId, 'clientId is a required param of getOrderDetails()');

    const headers = { 'Content-Type': 'application/json' };
    const orderId = externalOrderId && externalOrderId.toString().toUpperCase();
    const urlQueryString = queryString.stringify({ ...(withAccessProfile ? { accessProfile: 'YNAP_EXCHANGE' } : {}), email, langId }, { encode: false });

    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/orderhistory/v2/${orderId}?${urlQueryString}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getOrderDetails');
}
